"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Geo = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../BaseAvroRecord");
class Geo extends BaseAvroRecord_1.BaseAvroRecord {
    schema() {
        return Geo.schema;
    }
    subject() {
        return Geo.subject;
    }
}
exports.Geo = Geo;
Geo.subject = "geo";
Geo.schema = {
    "type": "record",
    "name": "Geo",
    "namespace": "storyblocks.common",
    "fields": [
        {
            "name": "countryCode",
            "type": "string"
        },
        {
            "name": "country",
            "type": "string"
        },
        {
            "name": "continent",
            "type": "string"
        }
    ]
};
//# sourceMappingURL=Geo.js.map